import { CompetitionCategoryType } from "./CompetitionCategoryType.js";

export const competitionCategoryTypeIncompatibilities: CompetitionCategoryType[][] = [
	[CompetitionCategoryType.Sptf1, CompetitionCategoryType.Sptf2],
	[CompetitionCategoryType.FreestyleStarters, CompetitionCategoryType.FreestyleOpen],
	[CompetitionCategoryType.QuadrupedWomen, CompetitionCategoryType.QuadrupedMen],
];
